// Uses window.jQuery rather than its own `import 'jquery'` - callers always await
// App.js's setUpSignalR() first, which guarantees window.jQuery is set. A static import here
// would defeat the point of loading jQuery on demand instead of bundling it eagerly.
export const reconnectSignalR = async () => {
  const $ = window.jQuery;
  await $.connection.hub.stop();
  await $.connection.hub.start();
};
